export default __webpack_public_path__ + "static/media/07-ideation-principles.869fed2b.svg";